import { render } from "./TestReportspeedmobile.vue?vue&type=template&id=b50ab4a8&scoped=true&ts=true"
import script from "./TestReportspeedmobile.vue?vue&type=script&lang=ts"
export * from "./TestReportspeedmobile.vue?vue&type=script&lang=ts"

import "./TestReportspeedmobile.vue?vue&type=style&index=0&id=b50ab4a8&scoped=true&lang=css"
import "./TestReportspeedmobile.vue?vue&type=style&index=1&id=b50ab4a8&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b50ab4a8"]])

export default __exports__